export const rulesState = state => state
